<!-- @format -->

<div class="admin-panel-container">
  <div class="pageTitle">
    <h2 class="pageTitleText">Accounts</h2>
    <p class="pageTitleTextNote">Create or modify user timesheet accounts using the panel below.</p>
  </div>

  <div class="baseControls">
    <div class="searchControl">
      <span><i class="fa-solid fa-magnifying-glass"></i></span>
      <input
        type="text"
        [(ngModel)]="searchText"
        (input)="handleSearchInput()"
        placeholder="Search"
        autocomplete="off"
        aria-autocomplete="none" />
      </div>

      <div class="addUserControl">
        <button class="btn btn-primary" (click)="handleAddNewUser()">Add new user</button>
      </div>
    </div>

    <div class="usersListContainer">
      <div class="usersListTable">
        <table class="table">
          <tr>
            <th class="name"><span>User</span></th>
            <th class="email">Email</th>
            <th class="empNum">Emp #</th>
            <th class="roles">Roles</th>
            <th class="ADGroup">AD Groups</th>
            <th class="manager">Manager</th>
            <th class="timekeeper">Timekeeper</th>
            <th class="createdAt">Created At</th>
            <th class="status">Status</th>
          </tr>

          @for (user of filteredUsers; track user) {
            <tr class="userEntry" (click)="handleUserEntryClick(user)">
              <td class="name">
                <div class="d-flex justify-content-space nameHover">
                  <label class="container d-flex nameHover">
                    <div class="img nameHover">
                      <img class="profile_icon" [src]="getProfilePicture(user)" />
                    </div>
                    <div class="employeeName nameHover">{{getUserFullName(user)}}</div>
                  </label>
                </div>
              </td>
              <td class="email">{{user.email}}</td>
              <td class="empNum">{{user.employeeNumber}}</td>
              <td class="roles">{{getUserRole(user)}}</td>
              <td class="ADGroup">{{user.enrolledGroups}}</td>
              <td class="manager">{{getManager(user)}}</td>
              <td class="timekeeper">{{getTimekeeper(user)}}</td>
              <td class="createdAt">{{getCreatedAtDate(user)}}</td>
              <td class="status">{{getUserActiveState(user)}}</td>
            </tr>
          }
        </table>
      </div>
    </div>

    <app-pagination-control
      [contentPerPage]="UsersPerPage"
      [totalContentLength]="totalContentLength"
      (onPaginationUpdate)="updatePaginationDetails($event)">
    </app-pagination-control>
  </div>

  <ng-template #accountsModal>
    <div class="accounts-modal-container">
      <form [formGroup]="accountsForm">
        <div class="accountsModal">
          <div class="modal-header">
            @if (isAccountUpdateModal) {
              <h4 class="modal-title" id="modal-basic-title">Edit User Account</h4>
            }
            @if (!isAccountUpdateModal) {
              <h4 class="modal-title" id="modal-basic-title">Add User Account</h4>
            }
            <button type="button" class="btn-close" aria-label="Close" (click)="dismissModal()"></button>
          </div>

          <div class="modal-body">
            <div class="row mb-3">
              <div class="col-4">
                <label class="form-label">First Name</label>
              </div>

              <div class="col-8">
                <div class="input-group">
                  @if (isAccountUpdateModal) {
                    <input
                      class="firstNameInput form-control"
                      formControlName="firstName"
                      type="text"
                      id="firstName"
                      name="firstName"
                      required
                      [class.is-invalid]="getControl('firstName').invalid && getControl('firstName').touched" />
                    }

                    @if (!isAccountUpdateModal) {
                      <input
                        class="firstNameInput form-control"
                        formControlName="firstName"
                        type="text"
                        id="firstName"
                        [inputFormatter]="formatter"
                        name="firstName"
                        [ngbTypeahead]="azureUserSearch"
                        [resultTemplate]="rt"
                        (selectItem)="onAzureUserSelect($event)"
                        required
                        [class.is-invalid]="getControl('firstName').invalid && getControl('firstName').touched" />
                      }
                    </div>
                  </div>
                </div>

                <div class="row mb-3">
                  <div class="col-4">
                    <label class="form-label">Last Name</label>
                  </div>

                  <div class="col-8">
                    <div class="input-group">
                      <input
                        class="lastNameInput form-control"
                        formControlName="lastName"
                        type="text"
                        id="lastNameField"
                        name="lastNameField"
                        required
                        [class.is-invalid]="getControl('lastName').invalid && getControl('lastName').touched" />
                      </div>
                    </div>
                  </div>

                  <div class="row mb-3">
                    <div class="col-4">
                      <label class="form-label">Email</label>
                    </div>

                    <div class="col-8">
                      <div class="input-group">
                        <input
                          class="emailInput form-control"
                          formControlName="email"
                          type="text"
                          id="emailField"
                          name="emailField"
                          required
                          [class.is-invalid]="getControl('email').invalid && getControl('email').touched" />
                        </div>
                      </div>
                    </div>

                    <div class="row mb-3">
                      <div class="col-4">
                        <label class="form-label">UPN</label>
                      </div>

                      <div class="col-8">
                        <div class="input-group">
                          <input
                            class="upnInput form-control"
                            formControlName="upn"
                            type="text"
                            id="upnField"
                            name="upnField"
                            required
                            [class.is-invalid]="getControl('upn').invalid && getControl('upn').touched" />
                          </div>
                        </div>
                      </div>

                      <div class="row mb-3">
                        <div class="col-4">
                          <label class="form-label">Employee Number</label>
                        </div>

                        <div class="col-8">
                          <div class="input-group">
                            <input
                              class="employeeNumInput form-control"
                              formControlName="employeeNum"
                              type="text"
                              id="employeeNumField"
                              name="employeeNumField"
                              required
                              [class.is-invalid]="getControl('employeeNum').invalid && getControl('employeeNum').touched" />
                            </div>
                          </div>
                        </div>

                        <div class="row mb-3">
                          <div class="col-4">
                            <label class="form-label">User is a manager</label>
                          </div>

                          <div class="col-8">
                            <select class="form-select" formControlName="isManager" (change)="setSelfManagerLock()">
                              <option [value]="true">Yes</option>
                              <option [value]="false">No</option>
                            </select>
                          </div>
                        </div>

                        <div class="row mb-3">
                          <div class="col-4">
                            <label class="form-label">User is a timekeeper</label>
                          </div>

                          <div class="col-8">
                            <select class="form-select" formControlName="isTimekeeper" (change)="setSelfTimekeeperLock()">
                              <option [value]="true">Yes</option>
                              <option [value]="false">No</option>
                            </select>
                          </div>
                        </div>

                        <div class="row mb-3">
                          <div class="col-4">
                            <label class="form-label">User is HR</label>
                          </div>

                          <div class="col-8">
                            <select class="form-select" formControlName="isHR">
                              <option [value]="true">Yes</option>
                              <option [value]="false">No</option>
                            </select>
                          </div>
                        </div>

                        <div class="row mb-3">
                          <div class="col-4">
                            <label class="form-label">User is postings exempt</label>
                          </div>

                          <div class="col-8">
                            <select class="form-select" formControlName="isClosePostingsIgnored">
                              <option [value]="true">Yes</option>
                              <option [value]="false">No</option>
                            </select>
                          </div>
                        </div>

                        <div class="row mb-3">
                          <div class="col-4">
                            <label class="form-label">Manager</label>
                          </div>

                          <div class="col-8">
                            <select class="form-select" formControlName="manager">
                              <option [value]="null" selected disabled>Select one</option>
                              @for (manager of managerUsers; track manager) {
                                <option [ngValue]="manager.id" [disabled]="!manager.active">{{getUserFullName(manager)}}</option>
                              }
                            </select>
                          </div>
                        </div>

                        <div class="row mb-3">
                          <div class="col-4">
                            <label class="form-label">Timekeeper</label>
                          </div>

                          <div class="col-8">
                            <select class="form-select" formControlName="timekeeper">
                              <option [value]="null" selected disabled>Select one</option>
                              @for (timekeeper of timekeeperUsers; track timekeeper) {
                                <option [ngValue]="timekeeper.id" [disabled]="!timekeeper.active">{{getUserFullName(timekeeper)}}</option>
                              }
                            </select>
                          </div>
                        </div>

                        <div class="row mb-3">
                          <div class="col-4">
                            <label class="form-label">Status</label>
                          </div>

                          <div class="col-8">
                            <select class="form-select" formControlName="active">
                              <option [value]="true">Active</option>
                              <option [value]="false">Inactive</option>
                            </select>
                          </div>
                        </div>

                        <ng-template #rt let-r="result" let-t="term">
                          <div class="autofillRowResult">{{r.firstName}} {{r.lastName}} ({{r.email}})</div>
                        </ng-template>
                      </div>
                    </div>
                  </form>

                  <div class="modal-footer">
                    <button type="button" class="btn btn-link btn-submission-cancel" (click)="dismissModal()">Cancel</button>
                    <button class="btn btn-primary" type="submit" title="Submit" (click)="dismissModal(true)" [disabled]="accountsForm.invalid">
                      {{ isAccountUpdateModal ? "Update" : "Save"}}
                    </button>
                  </div>
                </div>
              </ng-template>
